import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Input, Typography} from "@material-tailwind/react";
import React, {useContext, useEffect, useRef, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {
  getServiceAgentBranchDiscount,
  getServiceSecondPaymentDiscount,
  postValidateServiceDiscount
} from "../../services/branch_discount/agent_branch_discount";
import {getPersonWalletBalance, getPersonWalletBalanceByPersonId} from "../../services/payment/payment";
import {parseInt} from "lodash";
import {getBranchCommissionServiceVat} from "../../services/branch_commission/branch_commission";
import {
  updateServiceFirstPayment,
  updateServicePayment,
  updateServiceSecondPayment
} from "../../services/service/service";
import {ServiceContext} from "../../context/service";
import html2canvas from "html2canvas";
import {
  updateBackOfficeServiceFirstPayment,
  updateBackOfficeServicePayment,
  updateBackOfficeServiceSecondPayment
} from "../../services/back_office/service";
import {postValidateBackOfficeServiceDiscount} from "../../services/back_office/discount";

export function InvoiceForm({person_id}) {

  const {
    service,
    branchInfo,
    modalOpen,
    setModalOpen,
    setStep,
    setLastDataRefresh,
    setChargeAmount,
    setChargeDiscountCode,
    chargeDiscountCode,
    totalDays,
    totalSideCost
  } = useContext(ServiceContext);


  const handleOpen = () => setModalOpen(!modalOpen);

  const [priceAfterDiscount, setPriceAfterDiscount] = useState(null);
  const [vat, setVat] = useState(null);
  const [branchVatPercentage, setBranchVatPercentage] = useState(null);

  const [firstPayment, setFirstPayment] = useState(null)
  const [firstPaymentVat, setFirstPaymentVat] = useState(null)
  const [firstPaymentWithVat, setFirstPaymentWithVat] = useState(null)
  const [secondPayment, setSecondPayment] = useState(null)
  const [secondPaymentVat, setSecondPaymentVat] = useState(null)
  const [secondPaymentWithVat, setSecondPaymentWithVat] = useState(null)

  const [wallet, setWallet] = useState({});
  const [balance, setBalance] = useState(null);

  const [buttonLoading, setButtonLoading] = useState(false);

  const [personId, setPersonId] = useState(person_id)

  const ref = useRef(null);

  const getDiscountedPrice = (referencePrice, percentage, maxValue) => {
    const discount = Math.min(
      Math.floor(referencePrice * parseInt(percentage) / 100),
      parseInt(maxValue),
    );
    return referencePrice - discount;
  };

  const getBranchDiscountedPrice = (referencePrice, percentage, value) => {
    const percentagePrice = Math.floor(referencePrice * (100 - parseInt(percentage)) / 100);
    return parseInt(value) > percentagePrice
      ? percentagePrice
      : referencePrice - parseInt(value);
  };

  useEffect(() => {
    setPersonId(person_id)
  }, [person_id]);


  async function handleSecondPaymentDiscount() {
    const data = {
      id: service.id,
    }
    const result = await getServiceSecondPaymentDiscount(data);

    if (result.status === 200) {
      const {discount_values} = result.data;
      if ((service.price * parseInt(discount_values.percentage) / 100) >= parseInt(discount_values.value)) {
        setPriceAfterDiscount(service.price - parseInt(discount_values.value));
      } else {
        setPriceAfterDiscount(getDiscountedPrice(service.price, discount_values.percentage, discount_values.value))
      }
      setDisCount(true)
    } else {
      setPriceAfterDiscount(service.price)
      setDisCount(false)
    }

  }

  useEffect(() => {
    if (service.status === "second_waiting") {
      handleSecondPaymentDiscount()
    }
  }, []);

  useEffect(() => {
    const total_vat = Math.ceil(priceAfterDiscount * branchVatPercentage / 100)
    const first_payment = Math.floor(priceAfterDiscount * 50 / 100)
    const first_payment_vat = Math.floor(total_vat * 50 / 100)
    const second_payment = priceAfterDiscount - first_payment
    const second_payment_vat = total_vat - first_payment_vat

    if (service.side_cost_payer === "agent") {
      setFirstPayment(first_payment + totalSideCost)
    } else {
      setFirstPayment(first_payment)
    }
    setSecondPayment(second_payment)
    setFirstPaymentVat(first_payment_vat)
    setSecondPaymentVat(second_payment_vat)
    setVat(total_vat)
    if (service.side_cost_payer === "agent") {
      setFirstPaymentWithVat(first_payment + first_payment_vat + totalSideCost)
    } else {
      setFirstPaymentWithVat(first_payment + first_payment_vat)
    }
    setSecondPaymentWithVat(second_payment + second_payment_vat)
  }, [priceAfterDiscount, branchVatPercentage, service.side_cost_payer, totalSideCost]);

  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    if (service.side_cost_payer === "agent") {
      setTotalPrice(priceAfterDiscount + vat + totalSideCost)
    } else {
      setTotalPrice(priceAfterDiscount + vat)
    }
  }, [vat]);

  const [discount, setDisCount] = useState(false)
  const [discountCode, setDisCountCode] = useState("")

  async function handleDiscountCode() {

    const data = {
      branch_id: service.branchId,
      discount_code: discountCode,
      agent_id: service.agentId,
      price: service.price,
    }

    let result;
    if (!personId) {
      result = await postValidateServiceDiscount(data);
    } else {
      result = await postValidateBackOfficeServiceDiscount(data, personId)
    }

    if (result.status === 200) {
      const {discount_values} = result.data;
      if ((service.price * parseInt(discount_values.percentage) / 100) >= parseInt(discount_values.value)) {
        setPriceAfterDiscount(service.price - parseInt(discount_values.value));
      } else {
        setPriceAfterDiscount(getDiscountedPrice(service.price, discount_values.percentage, discount_values.value))
      }
      setDisCount(true)
    } else {
      setPriceAfterDiscount(service.price)
      setDisCount(false)
    }
  }


  async function handleChargeDiscountCode() {
    const result = await getServiceAgentBranchDiscount(service.branch_id, chargeDiscountCode);
    if (result.status === 200) {
      const {branch_discount} = result.data;
      if ((service.price * (100 - parseInt(branch_discount.percentage)) / 100) >= parseInt(branch_discount.value)) {
        setPriceAfterDiscount(service.price - parseInt(branch_discount.value));
      } else {
        setPriceAfterDiscount(getBranchDiscountedPrice(service.price, branch_discount.percentage, branch_discount.value))
      }
      setDisCount(true)
    } else {
      setPriceAfterDiscount(service.price)
      setDisCount(false)
    }
  }

  useEffect(() => {
    setPriceAfterDiscount(service.price);

    async function getWalletData(agentBranchFeeId) {
      let wallet_result;
      if (!personId) {
        wallet_result = await getPersonWalletBalance();
      } else {
        wallet_result = await getPersonWalletBalanceByPersonId(personId);
      }
      if (wallet_result.status === 200) {
        const {person_wallet_balance} = wallet_result.data;
        setBalance(person_wallet_balance ?? 0)
      }
      const vat_result = await getBranchCommissionServiceVat(service.agent_id, service.branch_id)
      if (vat_result.status === 200) {
        const {agent_branch_vat} = vat_result.data;
        setBranchVatPercentage(agent_branch_vat);
      }

      if (chargeDiscountCode && chargeDiscountCode.length > 0) {
        setDisCountCode(chargeDiscountCode)
        handleChargeDiscountCode();
      }
    }

    getWalletData()
  }, [person_id]);

  const handleExport = async () => {
    if (!ref.current) return;

    const canvas = await html2canvas(ref.current, {
      ignoreElements: (el) => el.classList.contains("exclude"),
    });

    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = "پیش‌فاکتور خدمت.png";
    link.href = dataUrl;
    link.click();
  };

  const save_payment = async () => {

    setButtonLoading(true)
    const data = {
      id: service.id,
      agent_id: service.agent_id,
      branch_id: service.branch_id,
      person_id: service.person_id,
      service_price: priceAfterDiscount,
      service_vat: vat,
      discount_code: discountCode
    };

    let result;

    if (service.multi_payment) {
      if (service.status !== "second_waiting") {
        if (!personId) {
          result = await updateServiceFirstPayment(data);
        } else {
          result = await updateBackOfficeServiceFirstPayment(data);
        }
      } else {
        if (!personId) {
          result = await updateServiceSecondPayment(data);
        } else {
          result = await updateBackOfficeServiceSecondPayment(data);
        }
      }
    } else {
      if (!personId) {
        result = await updateServicePayment(data);
      } else {
        result = await updateBackOfficeServicePayment(data);
      }
    }

    if (result.status === 202) {
      setLastDataRefresh(Date.now())
      handleOpen()
    } else {
      setButtonLoading(false)
    }
  };

  const save = (tag) => {
    if (tag === 'return') {
      setStep("check")
    } else if (tag === 'payment') {
      if (!service.multi_payment) {
        if (priceAfterDiscount + vat <= balance) {
          save_payment()
        }
      } else {
        if (service.status !== "second_waiting") {
          if (firstPaymentWithVat <= balance) {
            save_payment()
          }
        } else {
          if (secondPaymentWithVat <= balance) {
            save_payment()
          }
        }
      }
    }
  };

  return (
    <>
      <Dialog size="sm" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen bg-none">
        <div ref={ref}>
          <DialogHeader className="bg-gray-800 rounded-t-2xl -mt-4">
            <Typography className="py-4 w-full text-white text-2xl z-10 textCenter">
              پیش‌فاکتور
            </Typography>
          </DialogHeader>

          <DialogBody className="flex flex-col gap-4 rounded-2xl overflow-y-scroll max-h-[530px] md:max-h-[700px]">

            {service.status !== "second_waiting" &&
              <div className="flex flex-row mb-2 exclude">
                <Input variant="standard"
                       className="flex flex-col w-1/2"
                       value={discountCode}
                       label={Dict('discount_code')}
                       placeholder={Dict('discount_code')}
                       onChange={(e) => {
                         setDisCountCode(e.target.value);
                       }}
                />
                <Button variant="outlined" size="sm" color="gray" onClick={handleDiscountCode}
                        className="rounded text-center min-w-fit">
                  اعمال کدتخفیف
                </Button>
              </div>
            }
            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('agent')}: `}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {`${service.agent_name} ${service.agent_family}`}
                </Typography>
              </div>
            </div>

            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('branch_title')}: `}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {branchInfo.branch_title}
                </Typography>
              </div>
            </div>

            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {`${Dict('topic')}: `}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {service.topic}
                </Typography>
              </div>
            </div>

            {service.challenge?.length > 0 &&
              <div className="flex flex-row justify-between border-b-2 mb-2">
                <div className="flex flex-col">
                  <Typography className="flex flex-col ml-2">
                    {`${Dict('challenge_2')}: `}
                  </Typography>
                </div>
                <div className="flex flex-col">
                  <Typography className="flex flex-col" color="blue-gray">
                    {service.challenge}
                  </Typography>
                </div>
              </div>
            }

            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {Dict('service_day') + ": "}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(totalDays, true) + " روز"}
                </Typography>
              </div>
            </div>

            <div className="flex flex-row justify-between border-b-2 mb-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {Dict('total_service_price') + ": "}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(service.price, true) + " ریال"}
                </Typography>
              </div>
            </div>

            {service.price !== priceAfterDiscount &&
              <>
                <div className="flex flex-row justify-between mb-4 pb-2 border-b-2">
                  <div className="flex flex-col">
                    <Typography className="flex flex-col ml-2">
                      {Dict('discount') + ": "}
                    </Typography>
                  </div>
                  <div className="flex flex-col">
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(service.price - priceAfterDiscount, true) + " ریال"}
                    </Typography>
                  </div>
                </div>

                <div className="flex flex-row justify-between mb-4 pb-2 border-b-2">
                  <div className="flex flex-col">
                    <Typography className="flex flex-col ml-2">
                      {Dict('after_discount') + ": "}
                    </Typography>
                  </div>
                  <div className="flex flex-col">
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(priceAfterDiscount, true) + " ریال"}
                    </Typography>
                  </div>
                </div>
              </>
            }

            <div className="flex flex-row justify-between mb-4 pb-2 border-b-2">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {persianNumberFormat(branchVatPercentage) + "% " + "ارزش افزوده: "}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(vat, true) + " ریال"}
                </Typography>
              </div>
            </div>

            {service.side_cost_payer === "agent" &&
              <div className="flex flex-row justify-between mb-4 pb-2 border-b-2">
                <div className="flex flex-col">
                  <Typography className="flex flex-col ml-2">
                    {Dict('total_side_costs') + ": "}
                  </Typography>
                </div>
                <div className="flex flex-col">
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(totalSideCost, true) + " ریال"}
                  </Typography>
                </div>
              </div>
            }

            <div className="flex flex-row justify-between py-2 pb-2 border-black border-b-4">
              <div className="flex flex-col">
                <Typography className="flex flex-col ml-2">
                  {Dict('total_price') + ": "}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(totalPrice, true) + " ریال"}
                </Typography>
              </div>
            </div>

            {service.multi_payment &&
              <>
                <div className="flex flex-row justify-between py-2 pb-4 border-black border-b-4">
                  <div className="flex flex-col">
                    <Typography className="flex flex-col ml-2">
                      {Dict('first_payment_with_vat') + ": "}
                    </Typography>
                  </div>
                  <div className={`flex flex-col`}>
                    <Typography className="flex flex-col" color="blue-gray"
                                variant={service.status === "waiting" ? "h5" : "body"}
                    >
                      {persianNumberFormat(firstPaymentWithVat, true) + " ریال"}
                    </Typography>
                  </div>
                </div>
                <div className="flex flex-row justify-between py-2 pb-4 border-black border-b-4">
                  <div className="flex flex-col">
                    <Typography className="flex flex-col ml-2">
                      {Dict('second_payment_with_vat') + ": "}
                    </Typography>
                  </div>
                  <div className="flex flex-col">
                    <Typography className="flex flex-col" color="blue-gray"
                                variant={service.status === "second_waiting" ? "h5" : "body"}
                    >
                      {persianNumberFormat(secondPaymentWithVat, true) + " ریال"}
                    </Typography>
                  </div>
                </div>
              </>
            }


            <Button className="exclude" variant="outlined" color="blue-gray" onClick={handleExport}>
              <span>دانلود پیش فاکتور</span>
            </Button>


          </DialogBody>
        </div>

        <DialogFooter className="space-x-2 justify-between bg-gray-800 rounded-b-2xl -mb-4">
          <div className="flex flex-row right-0">
            <Typography className="flex flex-col" color="white">
              {Dict('balance') + ": "}
            </Typography>
            <Typography className="flex flex-col" color="white">
              {persianNumberFormat(balance, true) + " ریال"}
            </Typography>
          </div>
          <div className=" flex flex-row mt-4 left-0 md:mt-0">
            <Button variant="text" color="white" onClick={() => {
              save('return')
            }}>
              <span>بازگشت</span>
            </Button>
            {((!service.multi_payment && priceAfterDiscount + vat <= balance) ||
                (service.multi_payment && firstPaymentWithVat <= balance && service.status !== "second_waiting") ||
                (service.multi_payment && secondPaymentWithVat <= balance && service.status === "second_waiting")
              ) &&
              <Button variant="gradient" color="gray" disabled={buttonLoading} loading={buttonLoading} onClick={() => {
                save('payment')
              }} className="ml-1">
                <span>پرداخت از کیف پول</span>
              </Button>
            }
            {((!service.multi_payment && priceAfterDiscount + vat > balance) ||
                (service.multi_payment && firstPaymentWithVat > balance && service.status !== "second_waiting") ||
                (service.multi_payment && secondPaymentWithVat > balance && service.status === "second_waiting")
              ) && !personId &&
              <Button variant="gradient" color="white" size="sm md:lg"
                      onClick={() => {
                        if (!service.multi_payment) {
                          setChargeAmount(priceAfterDiscount + vat - balance)

                        } else {
                          if (service.status !== "second_waiting") {
                            setChargeAmount(firstPaymentWithVat - balance)

                          } else {
                            setChargeAmount(secondPaymentWithVat - balance)
                          }
                        }
                        setChargeDiscountCode(discountCode)
                        setStep("charge_wallet")
                      }} className="ml-1">
                <span>شارژ کیف پول</span>
              </Button>
            }
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
